import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { BrowserStorageService, storageKeys } from './browser-storage.service';
import { createUniqueId } from './utils';

export function fooswarsAppInitializer(storage: BrowserStorageService): () => Observable<any> {
    return () => {
        let browserId = storage.local.getItem(storageKeys.browserId);
        if (!browserId) {
            browserId = createUniqueId();
            storage.local.setItem(storageKeys.browserId, browserId);
        }

        if (environment.production) {
            const script = document.createElement('script');
            script.defer = true;
            script.src = 'https://analytics.jandeu.cz/script.js';
            script.setAttribute('data-website-id', 'e9df9bcf-7200-4442-8cce-97e371f7688f');

            document.head.appendChild(script);
        }

        return of(null);
    };
}
